import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { TriggerToast } from '../globals/Toaster';
import { useAuthService } from '../hooks/services/useAuthService';
import Input from '../ui/Input';

const ForgotPassword: React.FC = (): React.ReactElement => {

  const authService = useAuthService()

  const [email, setEmail] = useState('');

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    authService.forgotPassword(email).then((response) => {
      TriggerToast(response.message, undefined, 'success')
    }).catch((error) => {
      TriggerToast(error.message, undefined, 'error')
    })
  };

  return (
    <div className="h-full mx-auto mt-[16px] block">
      <form method="POST" className="flex flex-col items-center" onSubmit={handleSubmit}>
        <Input value={email} onChange={handleEmailChange} type="email" label="Email address" name="email" id="email" placeholder="user@prismancy.com" />
        <button type="submit" name="submit" className="btn-primary" aria-label="Request Password Reset">
          Request Password Reset
        </button>
        <div className="block mt-[16px] text-md text-center w-full">
          <span className="px-1">Remember password?</span>
          <NavLink to="/login" className="text-heading text-sm font-semibold leading-5">Login</NavLink>
        </div>
      </form>
    </div>
  )
}

export default ForgotPassword;
